/**
 * @lodex-pro/web-shared/lib/use-debounced-value — a value that follows its input only once the
 * input has stopped changing for `delayMs` (OPEN-194).
 *
 * For search boxes whose text is part of a query key: typing "devo" changes the input four times
 * but the debounced value once, so one request goes out instead of four. The first render returns
 * the input as it is, so a search restored from the URL loads at once.
 */

import * as React from 'react';

/** The default search delay: long enough to cover a word typed at speed, short enough to feel live. */
export const SEARCH_DEBOUNCE_MS = 300;

export function useDebouncedValue<T>(value: T, delayMs = SEARCH_DEBOUNCE_MS): T {
  const [debounced, setDebounced] = React.useState(value);
  React.useEffect(() => {
    const t = setTimeout(() => setDebounced(value), delayMs);
    return (): void => clearTimeout(t);
  }, [value, delayMs]);
  return debounced;
}
